module.exports = __webpack_public_path__ + "img/icon-payment-check.ad990131.svg";